export default function LogoIcon({ ...rest }) {
  return (
    <img
      alt="HLB"
      src="/assets/images/logo-light.svg"
      style={{ display: 'block' }}
      {...rest}
    />
  );
}
